
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1e7e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1e7e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bxa0x", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $865a8a16446988ab$export$6503ec6e8aabbaf; }, function (v) { return $865a8a16446988ab$export$6503ec6e8aabbaf = v; });
var $865a8a16446988ab$export$6503ec6e8aabbaf;
var $865a8a16446988ab$export$f7ad0328861e2f03;
"use strict";
var $865a8a16446988ab$var$mapping = new Map();
function $865a8a16446988ab$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$865a8a16446988ab$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $865a8a16446988ab$var$resolve(id) {
    var resolved = $865a8a16446988ab$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$865a8a16446988ab$export$6503ec6e8aabbaf = $865a8a16446988ab$var$register;
$865a8a16446988ab$export$f7ad0328861e2f03 = $865a8a16446988ab$var$resolve;

});

parcelRegister("236OM", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $17e12686bf321de3$export$bdfd709ae4826697; }, function (v) { return $17e12686bf321de3$export$bdfd709ae4826697 = v; });
$parcel$export(module.exports, "getOrigin", function () { return $17e12686bf321de3$export$5a759dc7a1cfb72a; }, function (v) { return $17e12686bf321de3$export$5a759dc7a1cfb72a = v; });
var $17e12686bf321de3$export$bdfd709ae4826697;
var $17e12686bf321de3$export$c9e73fbda7da57b6;
var $17e12686bf321de3$export$5a759dc7a1cfb72a;
"use strict";
var $17e12686bf321de3$var$bundleURL = {};
function $17e12686bf321de3$var$getBundleURLCached(id) {
    var value = $17e12686bf321de3$var$bundleURL[id];
    if (!value) {
        value = $17e12686bf321de3$var$getBundleURL();
        $17e12686bf321de3$var$bundleURL[id] = value;
    }
    return value;
}
function $17e12686bf321de3$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $17e12686bf321de3$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $17e12686bf321de3$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $17e12686bf321de3$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$17e12686bf321de3$export$bdfd709ae4826697 = $17e12686bf321de3$var$getBundleURLCached;
$17e12686bf321de3$export$c9e73fbda7da57b6 = $17e12686bf321de3$var$getBaseURL;
$17e12686bf321de3$export$5a759dc7a1cfb72a = $17e12686bf321de3$var$getOrigin;

});

var $19a4e67dd1fdac8a$exports = {};


(parcelRequire("bxa0x")).register((parcelRequire("236OM")).getBundleURL("h0RaO"), JSON.parse('["h0RaO","composition.373e2b28.js","hkwov","metronomeworker.293edca0.js","8kSxM","worker.948a5941.js","9liRF","imgtestlatdemo.92f5146f.webp"]'));


//# sourceMappingURL=composition.runtime.66e5860b.js.map
